import { useEffect, useState } from 'react';
import InputField from '../../../components/Forms/Input/InputField';
import SimpleSearchSelect from '../../../components/Forms/Input/SimpleSearchSelect';
import { useBranch } from '../../../hooks/branches/useBranch';
import { useProduct } from '../../../hooks/useProduct';
import { useInitialStock } from '../../../hooks/inventory/useInitialStock';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  setForm,
  resetForm,
} from '../../../store/slices/inventory/initialStockSlice';

const InitialStockFormSection = () => {
  const dispatch: AppDispatch = useDispatch();
  const { branchDropdown, fetchBranchDropdown } = useBranch();
  const { productsDropdown, handlerGetProductsForDropdown } = useProduct();
  const { handlerRegisterInitialStock, isSubmitting } = useInitialStock();
  const { form } = useSelector((state: RootState) => state.initialStock);

  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    fetchBranchDropdown();
    handlerGetProductsForDropdown();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(setForm({ [name]: value }));
  };

  const handleSelect = (name: string, option: any) => {
    dispatch(setForm({ [name]: option.id }));
  };

  const handleSave = async () => {
    const newErrors: typeof errors = {};

    if (!form.branchId) newErrors.branchId = 'Sucursal requerida';
    if (!form.productId) newErrors.productId = 'Producto requerido';
    if (!form.quantity) newErrors.quantity = 'Cantidad requerida';
    if (!form.unitCost) newErrors.unitCost = 'Costo unitario requerido';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    await handlerRegisterInitialStock();
  };

  const handleReset = () => {
    dispatch(resetForm());
    setErrors({});
  };

  return (
    <div className="rounded-sm border border-stroke bg-white p-7 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <SimpleSearchSelect
            label="Sucursal"
            name="branchId"
            iconKey="branch"
            options={branchDropdown}
            selectedValue={form.branchId ? Number(form.branchId) : null}
            onSelect={(option: any) => handleSelect('branchId', option)}
            error={errors.branchId}
            required
          />

          <SimpleSearchSelect
            label="Producto"
            name="productId"
            iconKey="product"
            options={productsDropdown}
            selectedValue={form.productId ? Number(form.productId) : null}
            onSelect={(option: any) => handleSelect('productId', option)}
            error={errors.productId}
            required
          />
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            label="Cantidad Inicial"
            name="quantity"
            type="number"
            iconKey="product"
            min={0}
            placeholder="Ej: 25"
            value={form.quantity !== null ? form.quantity : ''}
            onChange={handleChange}
            error={errors.quantity}
            required
          />

          <InputField
            label="Costo Unitario"
            name="unitCost"
            type="number"
            iconKey="dollar"
            min={0}
            placeholder="Ej: 4.50"
            value={form.unitCost !== null ? form.unitCost : ''}
            onChange={handleChange}
            error={errors.unitCost}
            required
          />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={handleSave}
            disabled={isSubmitting}
            className="rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90 disabled:opacity-50"
          >
            {isSubmitting ? 'Guardando...' : 'Guardar'}
          </button>
          <button
            type="button"
            onClick={handleReset}
            disabled={isSubmitting}
            className="rounded bg-slate-500 px-4 py-2 text-white hover:bg-opacity-90 disabled:opacity-50"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default InitialStockFormSection;
